import React from 'react';
import { ROUTING_CONFIG, providerSubmitSessionRoute } from '@uplift/constants';
import { ClinicalNotesPageContent } from '../clinical-notes-page';
import { Button, ProviderLayout } from '@uplift/ui-v2';
import { useAppointmentByIdQuery } from '@uplift/queries';
import { AppointmentType } from '@uplift/api';
import { PsychiatryNotesPageContent } from './PsychiatryNotes.page';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';


export const SubmitSessionPageContent: React.VFC = () => {
  const { appointmentId } = providerSubmitSessionRoute.useParams();
  const { data: appointment } = useAppointmentByIdQuery(appointmentId, { suspense: true });

  if (appointment?.state === 'submited') {
    return (
      <Box flex="0.7" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
        <Box>
          <Typography>This session has already been submitted</Typography>
        </Box>
        <Box mt={2}>
          <Button component={Link} to={ROUTING_CONFIG.notSubmittedSessions} color="secondary" variant="contained">Go back</Button>
        </Box>
      </Box>
    );
  }

  if (appointment?.type === AppointmentType.therapy) {
    return (
      <ClinicalNotesPageContent
        appointmentId={appointment.id}
      />
    );
  } else if (appointment?.type === AppointmentType.psychiatry) {
    return (
      <PsychiatryNotesPageContent
        appointmentId={appointment.id}
      />
    );
  }
};


export const SubmitSessionPage: React.VFC = () => {
  return (
    <ProviderLayout
      logoLink=""
      background="white"
      navigationVariant="clear"
      showClientsSearch={false}
      showNavigationLinks={false}
    >
      <SubmitSessionPageContent />
    </ProviderLayout>
  );
};
